import { render, staticRenderFns } from "./DataTableViewer.vue?vue&type=template&id=58773912&"
import script from "./DataTableViewer.vue?vue&type=script&lang=js&"
export * from "./DataTableViewer.vue?vue&type=script&lang=js&"
import style0 from "./DataTableViewer.vue?vue&type=style&index=0&id=58773912&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports